import React from 'react';
import { FieldArray, FieldArrayRenderProps } from 'formik';
import { AddButton, Wrapper, RemoveButton, Row } from './styles';
import Group from 'components/molecules/Group';
import Icon from 'components/atoms/Icon';
import { useTranslation } from 'react-i18next';
import { get } from 'lodash-es';

interface FormArrayProps<TItem> {
    name: string;
    item?: TItem;
    renderFields: (index: number, values: TItem[]) => React.ReactNode;
    addText?: string;
}

const FormArray = <TItem, >({ name, item, renderFields, addText }: FormArrayProps<TItem>) => {
    const { t } = useTranslation();
    
    return (
        <FieldArray name={name}>
            {(arrayHelpers: FieldArrayRenderProps) => {
                const values = get(arrayHelpers.form.values, name) as TItem[] || [];

                return (
                    <Wrapper>
                        {values.map((_, index) => (
                            <Row key={index}>
                                {renderFields(index, values)}
                                <RemoveButton type="button" onClick={() => arrayHelpers.remove(index)}>
                                    <Icon name="bin" size={1.2} />
                                </RemoveButton>
                            </Row>
                        ))}
                        <Group right>
                            <AddButton type="button" onClick={() => arrayHelpers.push(item ?? {})}>
                                <Icon name="add" size={1} /> <div>{addText ?? t('add')}</div>
                            </AddButton>
                        </Group>
                    </Wrapper>
                );
            }}
        </FieldArray>
    );
};

export default FormArray;
